
interface TodayProductionProps {
  data: any;
}

export function TodayProduction({ data }: TodayProductionProps) {
  if (!data) return null;

  return (
    <div className="bg-gradient-to-br from-yellow-50 to-orange-50 rounded-xl shadow-sm p-6 border-2 border-yellow-200 hover:shadow-lg transition-all duration-300">
      <div className="flex items-center justify-between mb-4">
        <div className="bg-gradient-to-br from-yellow-400 to-orange-500 w-12 h-12 rounded-lg flex items-center justify-center shadow-lg">
          <i className="ri-sun-line text-white w-6 h-6 flex items-center justify-center text-2xl"></i>
        </div>
        <div className="text-right">
          <div className="text-xs text-yellow-600 font-semibold bg-yellow-100 px-2 py-1 rounded-full">
            PRODUCCIÓN
          </div>
        </div>
      </div>

      <h3 className="text-sm font-semibold text-gray-700 mb-3">
        Producción Actualizada
      </h3>

      <div className="space-y-3">
        <div>
          <div className="flex items-baseline space-x-1 mb-1">
            <span className="text-3xl font-bold text-yellow-700">
              {data.total.toFixed(1)}
            </span>
            <span className="text-sm font-semibold text-yellow-600">kWh</span>
          </div>
          <p className="text-xs text-gray-600">Total producido hoy</p>
        </div>

        <div className="grid grid-cols-2 gap-3 pt-3 border-t border-yellow-200">
          <div>
            <div className="text-lg font-bold text-yellow-700">
              {data.peak.toFixed(1)}
            </div>
            <p className="text-xs text-gray-600">Pico (kW)</p>
            <p className="text-xs text-yellow-600 font-medium">{data.peakTime}</p>
          </div>
          
          <div>
            <div className="text-lg font-bold text-yellow-700">
              {data.efficiency}%
            </div>
            <p className="text-xs text-gray-600">Eficiencia</p>
            <div className="w-full bg-yellow-200 rounded-full h-1.5 mt-1">
              <div 
                className="bg-yellow-500 h-1.5 rounded-full transition-all duration-500"
                style={{ width: `${data.efficiency}%` }}
              ></div>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-4 flex items-center space-x-2">
        <div className="w-2 h-2 bg-yellow-500 rounded-full animate-pulse"></div>
        <span className="text-xs text-gray-600 font-medium">Actualizando en vivo</span>
      </div>
    </div>
  );
}
